import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Breadcrumb from "../Breadcrumb/Main";
import CtaFive from "../Menabout/CtaFive";
import PackageOne from "../Menpackage/PackageOne";
import PackageBanner from "../Menpackage/PackageBanner";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-3" />
            <main className="site-main">
              <Breadcrumb title="Home" subtitle="Pricing Package" />
              <PackageBanner />
              <PackageOne />
              <CtaFive />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
